import { render, staticRenderFns } from "./appliance-dish-add.vue?vue&type=template&id=686d27da&"
import script from "./appliance-dish-add.vue?vue&type=script&lang=js&"
export * from "./appliance-dish-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports